module.exports = __webpack_public_path__ + "img/PL.7268090f.svg";